export default {
    "__schema": {
        "queryType": {
            "fields": [
                {
                    "name": "products",
                    "args": [
                        {
                            "name": "filter",
                            "type": {
                                "inputFields": [
                                    {
                                        "name": "antenska_pozicija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "bluetooth",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "boja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "boja_zarulje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "brand",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "broj_megapixela",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "broj_nogu",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "broj_okretaja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "broj_svijeca",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "broj_vrata",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "broj_zarulja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "budilica",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "category_id",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "category_uid",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "cd",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "citanje_medija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "created_at",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dadatni_nastavci",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "depth",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterRangeTypeInput"
                                        }
                                    },
                                    {
                                        "name": "description",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "deterdzentposude",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "deterdzentrublje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dezen",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dijagonala_ekrana",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dimenzija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dimenzije",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dizajn",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dodaci",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dodatna_oprema",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dodatni_uvjeti",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "dual_sim",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "efekt",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "energetski_razred",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "energetski_razred_centrifuge",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "energetski_razred_eu",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "energetski_razred_grijanja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "energetski_razred_hladenja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "energetski_razred_susenja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "format",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "frost",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "funkcija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "grill",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "grlo",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "gsm",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "gsm_punjenje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "height",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterRangeTypeInput"
                                        }
                                    },
                                    {
                                        "name": "ima_i_susilicu",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "inspiration_category",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "ionizator",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "jacina_zarulje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "jamstvo",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kapacitet",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kapacitet_gb",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kapacitet_kg",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "karta",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kataloska",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kolekcija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kompaktnost",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "konekcija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kontrole",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kut_garniture",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "kvaliteta_zvuka",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "lifetime_status",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "madrac_u_kompletu",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "material",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "materijal",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "materijal2",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "materijal_2",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "materijal_izrade",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "materijal_okvira",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "materijal_uzglavlja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "miris",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "model",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "mogucnosti_snimanja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "montaza",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "mora_imati",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "motiv",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "nacin_ciscenja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "name",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "napajanje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "nastavci",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "news_from_date",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterTypeInput"
                                        }
                                    },
                                    {
                                        "name": "news_to_date",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterTypeInput"
                                        }
                                    },
                                    {
                                        "name": "nofrost",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "nosivost",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "oblik",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "okvir",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "opcije",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "operater",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "operativni_sustav",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "opticki_zoom",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "pakiranje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "periva_presvlaka",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "po_mjeri",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "podnica_u_kompletu",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "pohrana_na_medije",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "posebnosti",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "posuda",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "povezivost",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "povrsina_za_spavanje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "price",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterRangeTypeInput"
                                        }
                                    },
                                    {
                                        "name": "prijem_signala",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "prijemnik",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "primjena",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "procesor",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "productkind",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "productmodel",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "productstyle",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "producttype",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "promjer",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "punjenje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "radio",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "reprodukcija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "reprodukcija_videa",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "rezolucija",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "safety_info",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "salesunitinpackage",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterRangeTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sam",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sezona",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "short_description",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sirina",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sirina_cm",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "size",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sku",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "snaga",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sort",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "sorto",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "specificna_tezina",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "stil",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "svijeca",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "tehnike",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "tip",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "tip_ekrana",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "tip_punjenja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "tkanje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "toplinska_pumpa",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "tvrdoca",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "upotreba",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "uredaj",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "url_key",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "usb_ulaz",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "velicina_ekrana",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "vesa",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "visina",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "vrsta",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "vrsta_baterije",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "vrsta_obloge",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "vrsta_playera",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "vrsta_susilice",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "width",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterRangeTypeInput"
                                        }
                                    },
                                    {
                                        "name": "za_dimenziju_slike",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "za_madrac_velicine",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zamp",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zanr",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zapremina",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zapremnina",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zarulja",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zatvaranje",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zavrsna_obrada",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zone",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    },
                                    {
                                        "name": "zvucnici",
                                        "type": {
                                            "kind": "INPUT_OBJECT",
                                            "name": "FilterEqualTypeInput"
                                        }
                                    }
                                ],
                                "kind": "INPUT_OBJECT",
                                "name": "ProductAttributeFilterInput"
                            }
                        }
                    ]
                }
            ]
        },
        "types": [{
            "kind": "INTERFACE",
            "name": "CartAddressInterface",
            "possibleTypes": [{"name": "BillingCartAddress"}, {"name": "ShippingCartAddress"}]
        }, {
            "kind": "INTERFACE",
            "name": "CartItemInterface",
            "possibleTypes": [{"name": "SimpleCartItem"}, {"name": "VirtualCartItem"}, {"name": "DownloadableCartItem"}, {"name": "ConfigurableCartItem"}, {"name": "BundleCartItem"}, {"name": "GiftCardCartItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductInterface",
            "possibleTypes": [{"name": "VirtualProduct"}, {"name": "SimpleProduct"}, {"name": "DownloadableProduct"}, {"name": "BundleProduct"}, {"name": "GroupedProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "CategoryInterface",
            "possibleTypes": [{"name": "CategoryTree"}]
        }, {
            "kind": "INTERFACE",
            "name": "CategoryProductInterface",
            "possibleTypes": [{"name": "CategoryProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "GuaranteeInterface",
            "possibleTypes": [{"name": "Guarantee"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductPriceInterface",
            "possibleTypes": [{"name": "ProductPrice"}]
        }, {
            "kind": "INTERFACE",
            "name": "MediaGalleryInterface",
            "possibleTypes": [{"name": "ProductImage"}, {"name": "ProductVideo"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductLinksInterface",
            "possibleTypes": [{"name": "ProductLinks"}]
        }, {
            "kind": "INTERFACE",
            "name": "RoutableInterface",
            "possibleTypes": [{"name": "CategoryTree"}, {"name": "CmsPage"}, {"name": "VirtualProduct"}, {"name": "SimpleProduct"}, {"name": "DownloadableProduct"}, {"name": "BundleProduct"}, {"name": "GroupedProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "CurrentStorePathsInterface",
            "possibleTypes": [{"name": "CurrentStorePath"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryDynamicAttributeInterface",
            "possibleTypes": [{"name": "GiftRegistryDynamicAttribute"}, {"name": "GiftRegistryRegistrantDynamicAttribute"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryItemInterface",
            "possibleTypes": [{"name": "GiftRegistryItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryDynamicAttributeMetadataInterface",
            "possibleTypes": [{"name": "GiftRegistryDynamicAttributeMetadata"}]
        }, {
            "kind": "INTERFACE",
            "name": "CreditMemoItemInterface",
            "possibleTypes": [{"name": "DownloadableCreditMemoItem"}, {"name": "BundleCreditMemoItem"}, {"name": "CreditMemoItem"}, {"name": "GiftCardCreditMemoItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "OrderItemInterface",
            "possibleTypes": [{"name": "DownloadableOrderItem"}, {"name": "BundleOrderItem"}, {"name": "OrderItem"}, {"name": "GiftCardOrderItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "InvoiceItemInterface",
            "possibleTypes": [{"name": "DownloadableInvoiceItem"}, {"name": "BundleInvoiceItem"}, {"name": "InvoiceItem"}, {"name": "GiftCardInvoiceItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "ShipmentItemInterface",
            "possibleTypes": [{"name": "BundleShipmentItem"}, {"name": "ShipmentItem"}, {"name": "GiftCardShipmentItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "WishlistItemInterface",
            "possibleTypes": [{"name": "SimpleWishlistItem"}, {"name": "VirtualWishlistItem"}, {"name": "DownloadableWishlistItem"}, {"name": "BundleWishlistItem"}, {"name": "GroupedProductWishlistItem"}, {"name": "ConfigurableWishlistItem"}, {"name": "GiftCardWishlistItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "AggregationOptionInterface",
            "possibleTypes": [{"name": "AggregationOption"}]
        }, {
            "kind": "INTERFACE",
            "name": "LayerFilterItemInterface",
            "possibleTypes": [{"name": "LayerFilterItem"}, {"name": "SwatchLayerFilterItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryOutputInterface",
            "possibleTypes": [{"name": "MoveCartItemsToGiftRegistryOutput"}, {"name": "GiftRegistryOutput"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryItemUserErrorInterface",
            "possibleTypes": [{"name": "MoveCartItemsToGiftRegistryOutput"}, {"name": "GiftRegistryItemUserErrors"}]
        }, {
            "kind": "INTERFACE",
            "name": "PhysicalProductInterface",
            "possibleTypes": [{"name": "SimpleProduct"}, {"name": "BundleProduct"}, {"name": "GroupedProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "CustomizableOptionInterface",
            "possibleTypes": [{"name": "CustomizableAreaOption"}, {"name": "CustomizableDateOption"}, {"name": "CustomizableDropDownOption"}, {"name": "CustomizableMultipleOption"}, {"name": "CustomizableFieldOption"}, {"name": "CustomizableFileOption"}, {"name": "CustomizableRadioOption"}, {"name": "CustomizableCheckboxOption"}]
        }, {
            "kind": "INTERFACE",
            "name": "CustomizableProductInterface",
            "possibleTypes": [{"name": "VirtualProduct"}, {"name": "SimpleProduct"}, {"name": "DownloadableProduct"}, {"name": "BundleProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "SwatchDataInterface",
            "possibleTypes": [{"name": "ImageSwatchData"}, {"name": "TextSwatchData"}, {"name": "ColorSwatchData"}]
        }, {
            "kind": "INTERFACE",
            "name": "SwatchLayerFilterItemInterface",
            "possibleTypes": [{"name": "SwatchLayerFilterItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductAttachmentsInterface",
            "possibleTypes": [{"name": "ProductAttachment"}]
        }]
    }
}
